import { useRef, useState } from "react";

export const Address = ({onInputChange, onInputBlur, onError, value}) => {

    const address  = useRef(null);

    const [inputValue, setInputValue] = useState(value || '');

    const handleInputChange = () => {
        const name = address.current.name;
        const value = address.current.value;
        setInputValue(value);
        onInputChange({name: name, value: value});
    }

    const handleInputBlur = () => {
        const name = address.current.name
        const value = address.current.value
        onInputBlur({name: name, value: value});
    }

    return (
        <div className="mb-3">
            <label className="form-label fs-6 fw-bold">Адресса</label>
            <div className="input-group">
                <input ref={address} type="text"  className="form-control  " name="address" value={inputValue} placeholder="Введіть адресу доставки" 
                    onChange={() => handleInputChange()}
                    onBlur={() => handleInputBlur()}
                />
            </div>
            {onError && onError['address'] && <div className="error-message">{onError['address']}</div>} 
        </div>
    )
}
// 
// 